import { UserInformation } from "@/api/signin";

import WhiteLabelLogo from "@/components/_module/loading/white-label-logo";
import AccountFailedPage from "@/components/pages/account/failed";
import PageTransition from "@/components/ui/PageTransition";
import useCreateAchBankLinkingSession from "@/features/bank-accounts/useCreateAchBankLinkingSession";
import { getLinkedAccountsUrl } from "@/router/paths";
import { saveBankLinkingSessionToStorage } from "@/utils/bank-linking-session";
import React, { useEffect } from "react";

interface SoftpointIframeProps {
	user: UserInformation;
	/** From guest business details; required before starting the ACH session. */
	companyName: string;
	iframeAccessToken: string;
	locationId: number;
}

function redirectToHostedLink(hostedLinkUrl: string) {
	try {
		if (window.top && window.top !== window.self) {
			window.top.location.href = hostedLinkUrl;
		} else {
			window.location.href = hostedLinkUrl;
		}
	} catch {
		window.location.href = hostedLinkUrl;
	}
}

const SoftpointIframe: React.FC<SoftpointIframeProps> = ({
	user,
	companyName,
	iframeAccessToken,
	locationId,
}) => {
	const { mutate, status } = useCreateAchBankLinkingSession();

	useEffect(() => {
		if (!companyName.trim()) {
			return;
		}
		mutate(
			{
				locationId,
				accessToken: iframeAccessToken,
				redirectUri: getLinkedAccountsUrl(),
				user,
				companyName,
			},
			{
				onSuccess: (result) => {
					saveBankLinkingSessionToStorage(result.session_id);
					redirectToHostedLink(result.hosted_link_url);
				},
			},
		);
	}, [iframeAccessToken]);

	if (status === "error") {
		return (
			<AccountFailedPage
				onTryAgainClick={() => {
					window.location.reload();
				}}
			/>
		);
	}

	return (
		<PageTransition>
			<div className="pt-4">
				{status === "pending" ? (
					<div
						className={
							"w-full h-[calc(100dvh-4rem-5rem)] pb-20 flex items-center justify-center absolute"
						}
					>
						<WhiteLabelLogo />
					</div>
				) : null}
			</div>
		</PageTransition>
	);
};

export default SoftpointIframe;
